import React from 'react';
import MapGL from '@urbica/react-map-gl';
import Draw from '@urbica/react-map-gl-draw';
import 'mapbox-gl/dist/mapbox-gl.css';
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';
import * as turf from '@turf/turf'
import RegionItem from "./RegionItem";
import {mapService, NotificationService} from "../../services";
import NotificationAlert from "react-notification-alert";

class RegionEditorMap extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            allFeatures: [],
            deletedFeaturesId: [],
            selectedFeature: null,
            data: {
                type: "FeatureCollection",
                features: []
            },
            viewport: {
                latitude: -27.470125,
                longitude:153.021072,
                zoom: 8
            },
            labelData: {
                type: "FeatureCollection",
                features: []
            },
        }
        this._map = React.createRef();
        this.notifyRef = React.createRef();
        this._draw = React.createRef();
        this.addedLabelLayer = false;
        this.simplifyOpts = {tolerance: 0.00001, highQuality: true};
    }

    onMapSourceLoaded = () => {
        // assuming 'map' is defined globally, or you can use 'this'
        if (this._map.current && this._map.current._map.getSource('mapbox-gl-draw-cold') && this._map.current._map.isSourceLoaded('mapbox-gl-draw-cold') && !this.addedLabelLayer) {

            this.addedLabelLayer = true;
            this._map.current._map.addSource('instyl-label-source', {
                'type': 'geojson',
                'data': this.state.labelData
            });
            this._map.current._map.addLayer({
                id: 'instyle-region-labels',
                type: 'symbol',
                source: 'instyl-label-source',
                'layout': {
                    'text-field': ['get', 'name',],
                    // 'text-variable-anchor': ['top', 'bottom', 'left', 'right'],
                    'text-radial-offset': 0.5,
                    'text-justify': 'center',
                },
            });
        }
    }
    //
    onMapLoaded = () => {

        this._map.current._map.on('sourcedata', this.onMapSourceLoaded);
        this.setState({bounds: this._map.current._map.getBounds()})
        mapService.getAllRegions().then(response => {
            var {data, allFeatures} = this.state;
            response.forEach(r => {
                var d = {
                    "id": r.PolyID,
                    "type": "Feature",
                    "properties": JSON.parse(r.PolyProperties),
                    "geometry": r.PolyGeom
                }
                //check this doesnt exist in there already
                var foundData = false;
                data.features.forEach((i, ix, obj) => {
                    if (i.id == r.PolyID) {
                        obj[ix] = d;
                        foundData = true;
                    }
                })
                if (!foundData) {
                    data.features.push(d);
                }
                var foundFeat = false;
                allFeatures.forEach((i, ix, obj) => {
                    if (i.id == r.PolyID) {
                        foundFeat = true;
                        obj[ix] = d
                    }
                })
                if (!foundFeat) {
                    allFeatures.push(d);
                }

            });
            this.setState({data:data, allFeatures:allFeatures})
            this._map.current._map.getSource('instyl-label-source').setData(data);

        }).catch(error => {
            this.refs.notificationAlert.notificationAlert(NotificationService.notify('tc', 4, "Error: "+error+". Functionality is disabled."));
        })

    }

    onDrawCreated = ({features}) => {
        if (features[0].geometry.type.toLowerCase() != "polygon") {
            this._draw.current._draw.delete(features[0].id);
            return false;
        }
        var {data, allFeatures} = this.state;
        var noCollisions = false;
        var maxLoops = 0;
        features[0] = turf.truncate(features[0]);
        try {
            while (!noCollisions && maxLoops < 10) {
                noCollisions = true;
                maxLoops ++;
                data.features.forEach( (cf, ix) => {
                    if (cf.id != features[0].id) {
                        if (turf.booleanOverlap(cf, features[0])) {
                            noCollisions = false;
                            var eraseResult = turf.difference(features[0], turf.simplify(cf, this.simplifyOpts));
                            if (eraseResult.geometry.type == 'Polygon') {
                                features[0].geometry = eraseResult.geometry;
                            } else if (eraseResult.geometry.type == 'MultiPolygon'){
                                //create a polygon from each of the results
                                //find the largest area polygon
                                //make that the new feature polygon
                                var largestIndex = 0;
                                var largestArea = 0;
                                for (var j = 0; j < eraseResult.geometry.coordinates.length; j++) {
                                    try {
                                        var p = turf.polygon(eraseResult.geometry.coordinates[j]);

                                        var a = turf.area(p);
                                        if (a > largestArea) {
                                            largestArea = a;
                                            largestIndex = j;
                                        }
                                    } catch(err) {
                                    }
                                }
                                var newp = turf.polygon(eraseResult.geometry.coordinates[largestIndex])
                                features[0].geometry = newp.geometry;
                            }
                        }

                    }
                })
                //unkink the polygon because this causes headaches, only set the largest polygon!
                try {
                    var u = turf.unkinkPolygon(features[0]);

                    var largestIndex = 0;
                    var largestArea = 0;
                    for(var j = 0; j < u.features.length; j++) {
                        var a = turf.area(u.features[j])
                        if (a > largestArea) {
                            largestArea = a;
                            largestIndex = j;
                        }
                    }
                    features[0].geometry = u.features[largestIndex].geometry;
                } catch (err) {
                    throw err;
                }
            }
        } catch (error) {
            if (error && error.message && error.message.includes("found non-noded intersection between")) {
                this._draw.current._draw.delete(features[0].id);
                this.refs.notificationAlert.notificationAlert(NotificationService.notify('tc', 4, "Non-node intersect error, changes rolled back"));
                return false;
            } else if (error && error.message) {
                this._draw.current._draw.delete(features[0].id);
                this.refs.notificationAlert.notificationAlert(NotificationService.notify('tc', 4, "Error: "+error.message));
                return false;
            } else {
                throw error;
            }
        }


        allFeatures.push(features[0]);
        data.features.push(features[0])
        this.setState({data: data, allFeatures: allFeatures});
        this._map.current._map.getSource('instyl-label-source').setData(data);
    }

    onDrawUpdate = ({features}) => {
        if (features[0].geometry.type.toLowerCase() != "polygon") {
            this._draw.current._draw.delete(features[0].id);
            return false;
        }
        features[0] = turf.truncate(features[0])
        const {data, allFeatures} = this.state;
        let currFIx = undefined;
        data.features.forEach((cx, ix) => {
            if (cx.id == features[0].id) {
                currFIx = ix;
            }
        });

        var noCollisions = false;
        var maxLoops = 0;
        try {
            while (!noCollisions && maxLoops < 10) {
                noCollisions = true;
                maxLoops ++;
                data.features.forEach( (cf, ix) => {
                    if (cf.id != features[0].id) {
                        if (turf.booleanOverlap(cf, features[0])) {
                            noCollisions = false;
                            var eraseResult = turf.difference(features[0], turf.simplify(cf, this.simplifyOpts));
                            if (eraseResult.geometry.type == 'Polygon') {
                                features[0].geometry = eraseResult.geometry;
                            } else if (eraseResult.geometry.type == 'MultiPolygon'){
                                //create a polygon from each of the results
                                //find the largest area polygon
                                //make that the new feature polygon
                                var largestIndex = 0;
                                var largestArea = 0;
                                for (var j = 0; j < eraseResult.geometry.coordinates.length; j++) {
                                    try {
                                        var p = turf.polygon(eraseResult.geometry.coordinates[j]);

                                        var a = turf.area(p);
                                        if (a > largestArea) {
                                            largestArea = a;
                                            largestIndex = j;
                                        }
                                    } catch(err) {
                                    }
                                }
                                var newp = turf.polygon(eraseResult.geometry.coordinates[largestIndex])
                                features[0].geometry = newp.geometry;
                            }
                        }

                    }
                })
                //unkink the polygon because this causes headaches, only set the largest polygon!
                try {
                    var u = turf.unkinkPolygon(features[0]);

                    var largestIndex = 0;
                    var largestArea = 0;
                    for(var j = 0; j < u.features.length; j++) {
                        var a = turf.area(u.features[j])
                        if (a > largestArea) {
                            largestArea = a;
                            largestIndex = j;
                        }
                    }
                    features[0].geometry = u.features[largestIndex].geometry;
                } catch (err) {
                    throw err;
                }
            }
        } catch (error) {
            if (error && error.message && error.message.includes("found non-noded intersection between")) {
                this._draw.current._draw.delete(features[0].id);
                this.refs.notificationAlert.notificationAlert(NotificationService.notify('tc', 4, "Non-node intersect error, changes rolled back"));
                return false;
            } else if (error && error.message) {
                this._draw.current._draw.delete(features[0].id);
                this.refs.notificationAlert.notificationAlert(NotificationService.notify('tc', 4, "Error: "+error.message));
                return false;
            } else {
                throw error;
            }
        }


        data.features[currFIx].geometry = features[0].geometry;

        //update the allfeatures array
        allFeatures.forEach((cf, ix, obj) => {
            if (cf.id == features[0].id) {
                obj[ix] = features[0];
            }
        })
        this.setState({data: data, allFeatures:allFeatures, labelData: data});
        this._map.current._map.getSource('instyl-label-source').setData(data);
    }

    onDrawDelete = ({features}) => {
        var {deletedFeaturesId, data} = this.state;
        if (!deletedFeaturesId.includes(features[0].id)) {
            data.features.forEach((cf, ix, obj) => {
                if (cf.id == features[0].id) {
                    obj.splice(ix, 1)
                }
            })
            deletedFeaturesId.push(features[0].id)
            this.setState({deletedFeaturesId:deletedFeaturesId, data:data, labelData: data});
            this._map.current._map.getSource('instyl-label-source').setData(data);
        }
        mapService.deleteRegion(features[0]).then(() => {
            this.refs.notificationAlert.notificationAlert(NotificationService.notify('tc', 2, "Region ("+features[0].properties.name+") Deleted"));
        });
    }

    onActionDeleted = (feature) => {
        //call the server to delete the region - soft delete?

        this._draw.current._draw.delete(feature.id);
        this.onDrawDelete({features: [feature]})
    }

    onShowDeleted = (id) => {
        const {allFeatures, data, deletedFeaturesId} = this.state;
        allFeatures.map(cf => {
            if (cf.id == id) {
                data.features.push(cf)
                this.setState({data: data})
                this.onDrawUpdate({features: [cf]})
            }
        });
        //this.onDrawUpdate({features: [feature]});
        var newDeleted = deletedFeaturesId.filter(v => {
            return (v != id);
        })
        this.setState({deletedFeaturesId: newDeleted});
    }

    onFeatureChange = (feature) => {
        var {data, allFeatures} = this.state;
        data.features.forEach((cf, ix, obj) => {
            if (cf.id == feature.id) {
                obj[ix] = feature;
            }
        });
        allFeatures.forEach((cf, ix, obj) => {
            if (cf.id == feature.id) {
                obj[ix] = feature;
            }
        });
        this.setState({data: data, allFeatures:allFeatures, labelData: data});
        this._map.current._map.getSource('instyl-label-source').setData(data);
    }

    onDrawSelectionChange = ({features}) => {
        const {selectedFeature} = this.state;
        let selectedFeatureId = null;
        if (features.length > 0) {
            selectedFeatureId = features[0].id;
        }
        if (selectedFeatureId != selectedFeature) {
            this.setState({selectedFeature: selectedFeatureId})
        }
    }

    onFeatureSave = (feature) => {
        if (!feature.properties.name || feature.properties.name.length == 0) {
            this.refs.notificationAlert.notificationAlert(NotificationService.notify('tc', 4, "Regions require a name before saving"));
            return;
        }
        mapService.saveRegion(feature).then(() => {
            this.refs.notificationAlert.notificationAlert(NotificationService.notify('tc', 2, "Region ("+feature.properties.name+") Saved"));
        })
    }


    render() {
        const {data, allFeatures, deletedFeaturesId} = this.state;
        return (
            <React.Fragment>
                <NotificationAlert ref="notificationAlert" />
                <MapGL
                    style={{ width: "100%", height: "50vh", minHeight: "50vh" }}
                    mapStyle="mapbox://styles/mapbox/light-v9"
                    accessToken={'pk.eyJ1IjoibmljaG9sb3BvbHVzIiwiYSI6ImNrM2V6OTl1cDAwdDMzbHJzdzJvd2FxdXoifQ.8GRXsHLt6V_8IjG2TbIYkA'}
                    latitude={this.state.viewport.latitude}
                    longitude={this.state.viewport.longitude}
                    zoom={this.state.viewport.zoom}
                    onViewportChange={(viewport) =>  {
                        this.setState({ viewport })
                    }}
                    ref={this._map}
                    onLoad={this.onMapLoaded}
                >
                    <Draw
                        ref={this._draw}
                        showLine={false}
                        onDrawCreate={this.onDrawCreated}
                        onDrawUpdate={this.onDrawUpdate}
                        onDrawDelete={this.onDrawDelete}
                        onDrawSelectionChange={this.onDrawSelectionChange}
                        data={data}
                        combineFeaturesControl={false}
                        lineStringControl={false}
                        pointControl={false}
                        uncombineFeaturesControl={false}
                        position={`top-left`}
                        onChange={(data) => {
                            this.setState({data: data});
                            this._map.current._map.getSource('instyl-label-source').setData(data)
                        }}
                    />
                </MapGL>
                <div className={'region-editor--region-list-wrapper'}>
                    {allFeatures.map(feature => {
                        var deleted = false;
                        var selected = this.state.selectedFeature == feature.id;
                        if (feature.geometry.type == 'Polygon') {
                            if (deletedFeaturesId.includes(feature.id)) {
                                deleted = true;
                            }
                            return (
                                <div key={feature.id}>
                                    <RegionItem
                                        deleted={deleted}
                                        selected={selected}
                                        feature={feature}
                                        onShowDeleted={this.onShowDeleted}
                                        onNameChange={this.onFeatureChange}
                                        onSalesAreaChange={this.onFeatureChange}
                                        onCalendarChange={this.onFeatureChange}
                                        onSelfBookChange={this.onFeatureChange}
                                        onSmallSystemChange={this.onFeatureChange}
                                        onLargeSystemChange={this.onFeatureChange}
                                        onDeleteClick={this.onActionDeleted}
                                        onSaveClick={this.onFeatureSave}
                                    />
                                </div>
                            )
                        }
                        return <React.Fragment/>
                    })}
                </div>
            </React.Fragment>
        )
    }
}

export default RegionEditorMap;
